<section class="statement-detail-page">
  <div class="page-head">
    <div>
      <h1>Statement details</h1>
      <p class="intro">Review metadata and processing state for this statement.</p>
    </div>
    <div class="head-actions">
      <a class="btn ghost" routerLink="/app/statements">Back to statements</a>
      <a class="btn primary" routerLink="/app/upload">Upload another</a>

      @if (statement) {
        <button
          type="button"
          class="btn secondary"
          [disabled]="!canRunReconciliation || isStartingRun"
          (click)="startReconciliation()"
        >
          {{ isStartingRun ? 'Running...' : 'Run reconciliation' }}
        </button>
      }
    </div>
  </div>

  @if (isLoading) {
    <div class="card"><p>Loading statement...</p></div>
  }

  @if (!isLoading && errorMessage) {
    <div class="message error-banner">{{ errorMessage }}</div>
  }

  @if (!isLoading && statement) {
    <div class="card detail-card">
      <div class="detail-grid">
        <div class="detail-row">
          <span class="label">ID</span>
          <span>{{ statement.id }}</span>
        </div>
        <div class="detail-row">
          <span class="label">Source name</span>
          <span>{{ statement.sourceName }}</span>
        </div>
        <div class="detail-row">
          <span class="label">Type</span>
          <span>{{ statement.type }}</span>
        </div>
        <div class="detail-row">
          <span class="label">Status</span>
          <span class="status-pill">{{ statement.status }}</span>
        </div>
        <div class="detail-row">
          <span class="label">Uploaded at</span>
          <span>{{ statement.uploadedAt | date:'medium' }}</span>
        </div>
      </div>

      @if (!canRunReconciliation) {
        <p class="helper-text">
          Reconciliation can be started only when the statement status is <strong>PROCESSED</strong>.
        </p>
      }
    </div>

    <div class="card">
      <div class="section-head">
        <h2>Reconciliation runs</h2>
        <button type="button" class="btn ghost small" (click)="loadRuns(statement.id)">Refresh</button>
      </div>

      @if (isRunsLoading) {
        <p>Loading reconciliation runs...</p>
      }

      @if (!isRunsLoading && runsErrorMessage) {
        <div class="message error-banner">{{ runsErrorMessage }}</div>
      }

      @if (!isRunsLoading && !runsErrorMessage && runs.length === 0) {
        <p class="helper-text">No reconciliation runs yet.</p>
      }

      @if (!isRunsLoading && runs.length > 0) {
        <div class="run-list">
          @for (run of runs; track run.runId) {
            <a
              class="run-row"
              [routerLink]="['/app/statements', statement.id, 'reconciliation', 'runs', run.runId]"
            >
              <div>
                <strong>{{ run.runId }}</strong>
                <p>Engine v{{ run.engineVersion }}</p>
              </div>
              <span>{{ run.generatedAt | date:'medium' }}</span>
            </a>
          }
        </div>
      }
    </div>
  }
</section>
